/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipFinancing } from './HomeownershipFinancing';
import {
    HomeownershipFinancingFromJSON,
    HomeownershipFinancingFromJSONTyped,
    HomeownershipFinancingToJSON,
} from './HomeownershipFinancing';
import type { HomeownershipRepresentation } from './HomeownershipRepresentation';
import {
    HomeownershipRepresentationFromJSON,
    HomeownershipRepresentationFromJSONTyped,
    HomeownershipRepresentationToJSON,
} from './HomeownershipRepresentation';

/**
 * The lock wizard's last step: details, representation, financing and the statement of interest (TXN-3478:
 * an expression of interest, nothing to sign).
 * 
 * `loi_accepted` must be true (the resident submitted the statement) and `signer_name` is the buyer's name. The
 * statement text itself is not sent: the server stores the hash of its own copy (`homeownership.loi`), the one
 * the page showed. `representation` is the resident's own agent or Mainstay's: `none` ("I'll go without an
 * agent") was removed by TXN-3478 and is refused for a new lock; a lock stored with it still reads.
 * @export
 * @interface HomeownershipLockRequest
 */
export interface HomeownershipLockRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockRequest
     */
    termsId: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockRequest
     */
    signerName: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockRequest
     */
    coBuyerName?: string;
    /**
     * 
     * @type {HomeownershipRepresentation}
     * @memberof HomeownershipLockRequest
     */
    representation: HomeownershipRepresentation;
    /**
     * 
     * @type {HomeownershipFinancing}
     * @memberof HomeownershipLockRequest
     */
    financing: HomeownershipFinancing;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipLockRequest
     */
    loiAccepted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipLockRequest
     */
    lenderConsent?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLockRequest
     */
    lenderConsentVersion?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLockRequest
     */
    loiVersion: number;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLockRequest
     */
    contractDeadlineDays?: number;
}

/**
 * Check if a given object implements the HomeownershipLockRequest interface.
 */
export function instanceOfHomeownershipLockRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "termsId" in value;
    isInstance = isInstance && "signerName" in value;
    isInstance = isInstance && "representation" in value;
    isInstance = isInstance && "financing" in value;
    isInstance = isInstance && "loiAccepted" in value;
    isInstance = isInstance && "loiVersion" in value;

    return isInstance;
}

export function HomeownershipLockRequestFromJSON(json: any): HomeownershipLockRequest {
    return HomeownershipLockRequestFromJSONTyped(json, false);
}

export function HomeownershipLockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLockRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'termsId': json['terms_id'],
        'signerName': json['signer_name'],
        'coBuyerName': !exists(json, 'co_buyer_name') ? undefined : json['co_buyer_name'],
        'representation': HomeownershipRepresentationFromJSON(json['representation']),
        'financing': HomeownershipFinancingFromJSON(json['financing']),
        'loiAccepted': json['loi_accepted'],
        'lenderConsent': !exists(json, 'lender_consent') ? undefined : json['lender_consent'],
        'lenderConsentVersion': !exists(json, 'lender_consent_version') ? undefined : json['lender_consent_version'],
        'loiVersion': json['loi_version'],
        'contractDeadlineDays': !exists(json, 'contract_deadline_days') ? undefined : json['contract_deadline_days'],
    };
}

export function HomeownershipLockRequestToJSON(value?: HomeownershipLockRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'terms_id': value.termsId,
        'signer_name': value.signerName,
        'co_buyer_name': value.coBuyerName,
        'representation': HomeownershipRepresentationToJSON(value.representation),
        'financing': HomeownershipFinancingToJSON(value.financing),
        'loi_accepted': value.loiAccepted,
        'lender_consent': value.lenderConsent,
        'lender_consent_version': value.lenderConsentVersion,
        'loi_version': value.loiVersion,
        'contract_deadline_days': value.contractDeadlineDays,
    };
}

